// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39_FO","colMin":"styles_colMin__28-9V"};